import { ChannelDingding } from '@/app/components/icons/ChannelDingding';
import { ChannelDiscord4 } from '@/app/components/icons/ChannelDiscord4';
import { ChannelFeishu } from '@/app/components/icons/ChannelFeishu';
import { ChannelQiwei } from '@/app/components/icons/ChannelQiwei';
import { ChannelTelegram } from '@/app/components/icons/ChannelTelegram';
import { ChannelWechat } from '@/app/components/icons/ChannelWechat';
import { SITE } from '@/app/constants';
import type { ChannelItem } from './types';

export const GUIDE_LINK =
  SITE === 'china'
    ? 'https://shengshu.feishu.cn/wiki/QYmJwbjpgi1DgekTrLucoYtpn4g'
    : 'https://shengshu.feishu.cn/wiki/FzNXwQzV7i7EOmkbbG1cN0Penoe';

export const CHANNEL_CONFIGS = {
  china: [
    {
      id: 'weixin',
      icon: ChannelWechat,
      type: 'qrcode',
      provider: 'CHANNEL_BIND_PROVIDER_WEIXIN',
      titleKey: {
        nav: 'channels.weixin.title.nav',
        card: 'channels.weixin.title.card',
        menu: 'channels.weixin.title.menu',
      },
      descriptionKey: { nav: 'channels.weixin.description.nav', card: 'channels.weixin.description.card' },
      modalTitleKey: 'channels.weixin.modalTitle',
      elementName: 'WeChat_integration',
    },
    {
      id: 'wecom',
      icon: ChannelQiwei,
      type: 'qrcode',
      provider: 'CHANNEL_BIND_PROVIDER_WECOM',
      titleKey: {
        nav: 'channels.wecom.title.nav',
        card: 'channels.wecom.title.card',
        menu: 'channels.wecom.title.menu',
      },
      descriptionKey: { nav: 'channels.wecom.description.nav', card: 'channels.wecom.description.card' },
      modalTitleKey: 'channels.wecom.modalTitle',
      elementName: 'WeCom_integration',
    },
    {
      id: 'feishu',
      icon: ChannelFeishu,
      type: 'config',
      titleKey: {
        nav: 'channels.feishu.title.nav',
        card: 'channels.feishu.title.card',
        menu: 'channels.feishu.title.menu',
      },
      descriptionKey: { nav: 'channels.feishu.description.nav', card: 'channels.feishu.description.card' },
      modalTitleKey: 'channels.feishu.modalTitle',
      elementName: 'feishu_intergration',
      fixedConfig: {
        is_lark: false,
      },
      fields: [
        {
          key: 'enabled',
          labelKey: 'fields.enabled.label',
          descriptionKey: 'fields.enabled.description',
          valueType: 'boolean',
          defaultValue: true,
        },
        {
          key: 'app_id',
          labelKey: 'fields.appId.label',
          placeholderKey: 'fields.appId.placeholder',
          descriptionKey: 'fields.feishuAppId.description',
          required: true,
        },
        {
          key: 'app_secret',
          labelKey: 'fields.appSecret.label',
          placeholderKey: 'fields.appSecret.placeholder',
          required: true,
        },
        {
          key: 'encrypt_key',
          labelKey: 'fields.encryptKey.label',
          placeholderKey: 'fields.encryptKey.placeholder',
        },
        {
          key: 'verification_token',
          labelKey: 'fields.verificationToken.label',
          placeholderKey: 'fields.verificationToken.placeholder',
        },
        {
          key: 'allow_from',
          labelKey: 'fields.allowFrom.label',
          placeholderKey: 'fields.allowFrom.placeholder',
          descriptionKey: 'fields.allowFrom.description',
          inputType: 'textarea',
          valueType: 'array',
        },
      ],
    },
    {
      id: 'dingtalk',
      icon: ChannelDingding,
      type: 'config',
      titleKey: {
        nav: 'channels.dingtalk.title.nav',
        card: 'channels.dingtalk.title.card',
        menu: 'channels.dingtalk.title.menu',
      },
      descriptionKey: { nav: 'channels.dingtalk.description.nav', card: 'channels.dingtalk.description.card' },
      modalTitleKey: 'channels.dingtalk.modalTitle',
      elementName: 'dingding_intergration',
      fields: [
        {
          key: 'enabled',
          labelKey: 'fields.enabled.label',
          descriptionKey: 'fields.enabled.description',
          valueType: 'boolean',
          defaultValue: true,
        },
        {
          key: 'client_id',
          labelKey: 'fields.clientId.label',
          placeholderKey: 'fields.clientId.placeholder',
          required: true,
        },
        {
          key: 'client_secret',
          labelKey: 'fields.clientSecret.label',
          placeholderKey: 'fields.clientSecret.placeholder',
          required: true,
        },
        {
          key: 'allow_from',
          labelKey: 'fields.allowFrom.label',
          placeholderKey: 'fields.allowFrom.placeholder',
          descriptionKey: 'fields.allowFrom.description',
          inputType: 'textarea',
          valueType: 'array',
        },
      ],
    },
  ],
  global: [
    {
      id: 'telegram',
      icon: ChannelTelegram,
      type: 'config',
      titleKey: {
        nav: 'channels.telegram.title.nav',
        card: 'channels.telegram.title.card',
        menu: 'channels.telegram.title.menu',
      },
      descriptionKey: { nav: 'channels.telegram.description.nav', card: 'channels.telegram.description.card' },
      modalTitleKey: 'channels.telegram.modalTitle',
      elementName: 'telegram_intergration',
      fields: [
        {
          key: 'enabled',
          labelKey: 'fields.enabled.label',
          descriptionKey: 'fields.enabled.description',
          valueType: 'boolean',
          defaultValue: true,
        },
        {
          key: 'token',
          labelKey: 'fields.telegramToken.label',
          placeholderKey: 'fields.telegramToken.placeholder',
          required: true,
        },
        {
          key: 'allow_from',
          labelKey: 'fields.allowFrom.label',
          placeholderKey: 'fields.allowFrom.placeholder',
          descriptionKey: 'fields.allowFrom.description',
          inputType: 'textarea',
          valueType: 'array',
        },
        {
          key: 'proxy',
          labelKey: 'fields.proxy.label',
          placeholderKey: 'fields.proxy.placeholder',
        },
        {
          key: 'use_markdown_v2',
          labelKey: 'fields.telegramMarkdownV2.label',
          descriptionKey: 'fields.telegramMarkdownV2.description',
          valueType: 'boolean',
          defaultValue: false,
        },
      ],
    },
    {
      id: 'discord',
      icon: ChannelDiscord4,
      type: 'config',
      titleKey: {
        nav: 'channels.discord.title.nav',
        card: 'channels.discord.title.card',
        menu: 'channels.discord.title.menu',
      },
      descriptionKey: { nav: 'channels.discord.description.nav', card: 'channels.discord.description.card' },
      modalTitleKey: 'channels.discord.modalTitle',
      elementName: 'discord_intergration',
      fields: [
        {
          key: 'enabled',
          labelKey: 'fields.enabled.label',
          descriptionKey: 'fields.enabled.description',
          valueType: 'boolean',
          defaultValue: true,
        },
        {
          key: 'token',
          labelKey: 'fields.discordToken.label',
          placeholderKey: 'fields.discordToken.placeholder',
          required: true,
        },
        {
          key: 'allow_from',
          labelKey: 'fields.allowFrom.label',
          placeholderKey: 'fields.allowFrom.placeholder',
          descriptionKey: 'fields.allowFrom.description',
          inputType: 'textarea',
          valueType: 'array',
        },
        {
          key: 'group_trigger',
          labelKey: 'fields.groupTrigger.label',
          placeholderKey: 'fields.groupTrigger.placeholder',
          descriptionKey: 'fields.groupTrigger.description',
          inputType: 'textarea',
          valueType: 'object',
        },
      ],
    },
  ],
} satisfies Record<'china' | 'global', ChannelItem[]>;
